import {
  LegacyCard,
  Pagination,
  LegacyStack,
  Badge,
  Divider,
  IndexTable,
  Link,
  Text,
  EmptyState,
  Card,
  Spinner,
  HorizontalStack,
  Icon,
} from '@shopify/polaris';
import moment from 'moment';
import { StatusBadge } from '../Common/StatusBadge';
import { CancelMajor } from '@shopify/polaris-icons';
import { truncateString } from '../../../helpers/truncateString';

const ListInventories = ({
  data,
  isLoading,
  error,
  fetchNextPage,
  hasNextPage,
  fetchPreviousPage,
  hasPreviousPage,
}) => {
  const showInventorieEndpoint = (depositId, id) => `/deposits/${depositId}/inventories/${id}`;

  const headingMarkup = [
    { title: 'Depósito' },
    { title: 'Nombre' },
    { title: 'Estado', alignment: 'center' },
    {},
    { title: 'Inicio', alignment: 'center' },
    { title: 'Diferencia', alignment: 'center' },
  ];

  const rowMarkup = (inventory, index) => {
    const { id, name, status, deposit, startDate, createdAt, partialSeries, partial } = inventory;
    return (
      <IndexTable.Row id={id} key={`r_${id}`} position={index}>
        <>
          <IndexTable.Cell>
            <Link dataPrimaryLink url={showInventorieEndpoint(deposit.id, id)}></Link>
            <Text variant="bodyMd" fontWeight="bold" as="span">
              {truncateString(deposit.name, 25)}
            </Text>
          </IndexTable.Cell>
          <IndexTable.Cell>
            <Text variant="bodyMd" as="span">
              <span
                style={{
                  display: 'inline-block',
                  maxWidth: '200px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {truncateString(name, 50)}
              </span>
            </Text>
          </IndexTable.Cell>
          <IndexTable.Cell>
            <StatusBadge type="inventory" status={status} />
          </IndexTable.Cell>
          <IndexTable.Cell>
            {partialSeries && (
              <Badge size="small" progress="partiallyComplete" status="warning">
                Por Modelos
              </Badge>
            )}
            {!partialSeries && partial && (
              <Badge size="small" progress="partiallyComplete" status="attention">
                Por Taxonomias
              </Badge>
            )}
            {!partialSeries && !partial && (
              <Badge size="small" progress="complete">
                Completo
              </Badge>
            )}
          </IndexTable.Cell>

          <IndexTable.Cell>
            <Text variant="bodySm" alignment="center">
              {moment(startDate || createdAt).format('DD-MM-YYYY')}
            </Text>
          </IndexTable.Cell>
          <IndexTable.Cell>
            <Text variant="bodySm" alignment="end">
              {Math.abs(inventory.stockQtyExpected - inventory.stockQtyFound)} Dif. de {inventory.stockQtyExpected}{' '}
              Esperados.
            </Text>
          </IndexTable.Cell>
        </>
      </IndexTable.Row>
    );
  };

  return (
    <>
      {isLoading ? (
        <Card>
          <HorizontalStack align="center" blockAlign="center">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '.5rem',
                padding: '1.5rem',
              }}
            >
              <Spinner accessibilityLabel="Cargando inventarios" size="large" />
              <Text variant="bodySm">Cargando inventarios...</Text>
            </div>
          </HorizontalStack>
        </Card>
      ) : error ? (
        <Card>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '.5rem',
              padding: '1.5rem',
            }}
          >
            <Icon source={CancelMajor} color="critical" size="large" />
            <Text variant="bodyMd">Error al cargar los inventarios</Text>
          </div>
        </Card>
      ) : (
        <>
          <IndexTable
            resourceName={{
              singular: 'inventario',
              plural: 'inventarios',
            }}
            itemCount={data?.length || 0}
            headings={headingMarkup}
            selectable={false}
            emptyState={
              <EmptyState
                heading="Todavía no hay ningún inventario"
                image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
              />
            }
          >
            {data?.map((r, k) => rowMarkup(r, k))}
          </IndexTable>
          <Divider borderStyle="divider" />
          <LegacyCard.Section>
            <LegacyStack distribution="center">
              <Pagination
                hasPrevious={!!hasPreviousPage}
                onPrevious={hasPreviousPage ? fetchPreviousPage : undefined}
                hasNext={!!hasNextPage}
                onNext={hasNextPage ? fetchNextPage : undefined}
              />
            </LegacyStack>
          </LegacyCard.Section>
        </>
      )}
    </>
  );
};

export default ListInventories;
